import React, { useEffect, useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, CartesianGrid, PieChart, Pie, Cell } from 'recharts';
import api from '../../utils/api';
import LoadingSpinner from '../../components_shared/LoadingSpinner';

const COLORS = ['#6366f1', '#f59e0b', '#0ea5e9', '#8b5cf6', '#ec4899', '#10b981'];

export default function EnrollmentAnalyticsPage() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/api/v1/reports/enrollment-trends')
      .then(r => setData(r.data || []))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <LoadingSpinner />;

  const pieData = data.map(r => ({ name: r.region, value: Number(r.total) }));

  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ marginBottom: 8 }}>Enrollment Analytics</h2>
      <p style={{ color: '#666', marginBottom: 24 }}>Regional trends and medium-wise distribution</p>

      <div className="row">
        <div className="col-md-8">
          <div style={{ background: '#fff', borderRadius: 12, padding: 24, boxShadow: '0 1px 4px rgba(0,0,0,.08)', marginBottom: 24 }}>
            <h4 style={{ marginBottom: 16 }}>Region-wise Enrollment</h4>
            <ResponsiveContainer width="100%" height={400}>
              <BarChart data={data} margin={{ top: 10, right: 30, left: 20, bottom: 5 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                <XAxis dataKey="region" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="sindhi" name="Sindhi Medium" fill="#6366f1" radius={[4, 4, 0, 0]} />
                <Bar dataKey="urdu" name="Urdu Medium" fill="#f59e0b" radius={[4, 4, 0, 0]} />
                <Bar dataKey="english" name="English Medium" fill="#0ea5e9" radius={[4, 4, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="col-md-4">
          <div style={{ background: '#fff', borderRadius: 12, padding: 24, boxShadow: '0 1px 4px rgba(0,0,0,.08)', marginBottom: 24 }}>
            <h4 style={{ marginBottom: 16 }}>Regional Share</h4>
            <ResponsiveContainer width="100%" height={400}>
              <PieChart>
                <Pie
                  data={pieData}
                  cx="50%"
                  cy="50%"
                  outerRadius={100}
                  fill="#8884d8"
                  dataKey="value"
                  label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                >
                  {pieData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      <div style={{ background: '#fff', borderRadius: 12, padding: 24, boxShadow: '0 1px 4px rgba(0,0,0,.08)' }}>
        <h4 style={{ marginBottom: 16 }}>Statistical Summary</h4>
        <table className="table">
          <thead>
            <tr>
              <th>Region</th>
              <th className="text-end">Sindhi</th>
              <th className="text-end">Urdu</th>
              <th className="text-end">English</th>
              <th className="text-end">Total</th>
            </tr>
          </thead>
          <tbody>
            {data.map((r, i) => (
              <tr key={i}>
                <td>{r.region}</td>
                <td className="text-end">{Number(r.sindhi).toLocaleString()}</td>
                <td className="text-end">{Number(r.urdu).toLocaleString()}</td>
                <td className="text-end">{Number(r.english).toLocaleString()}</td>
                <td className="text-end"><strong>{Number(r.total).toLocaleString()}</strong></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
